import React, { useEffect, useState } from "react";
import { Button, Modal, Radio, Spin, Steps, Tooltip, message } from "antd";
import { ArrowRightOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { SaveButton, ModalComponent, trans } from "@comps/components"


import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { createDataReq, getRelatedDataReq, getCompanyRelatedDataReq, getPreviewDataReq } from "../requests";
import { Commons } from "../../constants";
import FilterSelectEmployees from "@mods/common/FilterSelectEmployees";
import { createSelectList, convertTimeTotz } from '@comps/commonFunctions';
import StepOne from "../../common/StepOne";
import Preview from "../../common/Preview";
import { ShowErrorModal } from "@comps/components";
const formName = "createCompanyRoaster";

const CreateCompanyRoaster = (props) => {
  //============================
  const [, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [companyRelatedData, setCompanyRelatedData] = useState([]);
  const [companyRelatedLoading, setCompanyRelatedLoading] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedEmployments, setEmployments] = useState([]);
  const [previewEmployment, setPreviewEmployments] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [dates, setDates] = useState([]);
  //------------intitial steps state---------
  const [firstStepData, setFirstStepData] = useState(null);
  const [currentStep, setCurrent] = useState(0);

  const [preEmployeesFilter, setPreEmployeesFilter] = useState({})
  const [unSelectedEmployees, setUnSelectedEmployees] = useState([])
  const [selectedEmployees, setSelectedEmployees] = useState([])
  const [childComponent, setChildComponent] = useState(null)
  //=======================================
  const canOpenEmployeeStep = Boolean(firstStepData);
  const canOpenFinalStep = previewEmployment.length > 0;
  const hasCompanyRelatedData = companyRelatedData && Object.keys(companyRelatedData).length > 0;

  const stepTooltip = {
    time: "Choose the roster date range, repeat days, and time slot.",
    employees: "Filter employees, then move the required employees into the selected list.",
    finalise: "Review the selected time slot, breaks, employees, and shift dates before submitting."
  }

  const renderStepTitle = (title, tooltip) => (
    <span className="create-roster-step-title">
      <span>{ title }</span>
      <Tooltip title={ tooltip } placement="top">
        <InfoCircleOutlined className="create-roster-step-help" />
      </Tooltip>
    </span>
  )

  const onStepChange = (step) => {
    if (step === 1 && !canOpenEmployeeStep) {
      message.info("Complete Time and Date before selecting employees.");
      return;
    }

    if (step === 2 && !canOpenFinalStep) {
      message.info("Select at least one employee before finalising.");
      return;
    }

    if (step === 1) {
      getCompanyRemoteData();
    }

    setCurrent(step)
  }
  //=======================================
  useEffect(() => {
    getRemoteData()
    // eslint-disable-next-line
  }, []);
  const getRemoteData = () => {
    makeRequestStateless(getRelatedDataReq, null, ongetRelatedDataReq, null);
  }
  const getCompanyRemoteData = () => {
    if (hasCompanyRelatedData || companyRelatedLoading) {
      return;
    }
    setCompanyRelatedLoading(true);
    makeRequestStateless(getCompanyRelatedDataReq, null, ongetCompanyRelatedDataReq, () => setCompanyRelatedLoading(false));
  }
  const ongetCompanyRelatedDataReq = (response) => {
    setCompanyRelatedData(response)
    setCompanyRelatedLoading(false)
  }
  const ongetRelatedDataReq = (response) => {
    setTimeSlots(createSelectList(response.time_slots))
  }
  //==============================Save all Data=========================================
  const onSubmit = (firstStepData) => {

    if (firstStepData.is_full_overtime_shift === undefined) {
      firstStepData.is_full_overtime_shift = false
    }
    const payload = {
      shift: {
        auto_apply: firstStepData.auto_apply,
        time_slot_id: firstStepData.time_slot_id,
        is_full_overtime_shift: firstStepData.is_full_overtime_shift,
        days: firstStepData.days || [],
        dates: dates,
        employment_ids: selectedEmployments.employment_ids,
      }
    };
    if (firstStepData.auto_apply) {
      payload.shift.effective_date = firstStepData.effective_date;
      payload.shift.end_date = firstStepData.assignment_end_date;
    }

    let replaceExisting = false;
    Modal.confirm({
      title: firstStepData.auto_apply ? "Confirm auto-applied roster" : "Confirm one-time roster",
      content: <>
        <p>{ firstStepData.auto_apply
          ? `This roster will start from ${firstStepData.effective_date}${firstStepData.assignment_end_date ? ` and end on ${firstStepData.assignment_end_date}` : ", stay active until changed, and prepare the first 30 days of shifts"}. A later roster will override it from its effective date.`
          : "Auto apply is off. Klok will create shifts only for the selected date range and will not continue this roster automatically."
        }</p>
        <p>For employees who already have roster on the same date:</p>
        <Radio.Group defaultValue="skip" onChange={ (event) => { replaceExisting = event.target.value === "update" } }>
          <Radio value="skip">Skip existing roster</Radio>
          <Radio value="update">Update existing safe roster</Radio>
        </Radio.Group>
      </>,
      okText: "Confirm and submit",
      cancelText: "Review again",
      onOk: () => {
        payload.shift.replace_existing = replaceExisting;
        setSaveLoader(true)
        makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
      }
    });
  }

  const onSuccess = (data, res) => {

    setSaveLoader(false)
    if (data.errors.length > 0) {
      setChildComponent(<ShowErrorModal errors={ data.errors } module={ "Create Roster" } onCompleted={ () => setChildComponent(null) } />)
      return;
    }
    else {
      message.success("Shift Job Pushed successfully");
      props.onCreated(data);
    }

  }
  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //=================Submit First Step 1==============================================
  const getStepOneData = (data, dates) => {
    setFirstStepData(data);
    //setEmployments(data)
    setDates(dates)
    getCompanyRemoteData();
    setCurrent(currentStep + 1)
  }
  //=====================On Submit Second Step===========================
  const setSelectedEmploymentsIds = (employments) => {
    setEmployments(employments)
    let payload = { time_slot_id: firstStepData.time_slot_id, employment_ids: employments.employment_ids };
    makeRequest(setLoader, getPreviewDataReq, payload, onGetPreview, null);
    setCurrent(currentStep + 1)
  }
  const onGetPreview = (response) => {
    if (response) {
      response.time_slot.start = response.time_slot.start ? convertTimeTotz(response.time_slot.start) : null
      response.time_slot.end = response.time_slot.end ? convertTimeTotz(response.time_slot.end) : null;
      if (response.time_slot.breaks) {
        response.time_slot.breaks.forEach((each) => {
          each.start = each.start ? convertTimeTotz(each.start) : null;
          each.end = each.end ? convertTimeTotz(each.end) : null;
        })
      }
      setPreviewData(response)
      setPreviewEmployments(response.employments)
      setCurrent(currentStep + 1)
    }
  }
  const onCancel = () => {
    props.onCreated(false);
  }
  const onBack = () => {
    setCurrent(currentStep - 1)
  }

  // const onBack = () => {
  //   setCurrent(currentStep - 1)
  // }

  //================================Main Modal Component==================================
  return (
    <ModalComponent top={ 20 } width={ 980 } maskClosable={ false }
      className="create-roster-modal"
      rootClassName="create-roster-modal-root"
      bodyStyle={ { padding: 0 } }
      mainTitle={ (
        <div className="create-roster-modal-title">
          <span>{ trans(Commons.create) } Roster</span>
        </div>
      ) }
      visible={ true } onCancel={ () => props.onCreated(false) } footer={ '' }>

      <div className="create-roster-shell">
        <Steps
          className="create-roster-steps steps-style"
          current={ currentStep }
          onChange={ onStepChange }
          responsive
          size="small"
        >
          <Steps.Step
            className="steps-step1"
            title={ renderStepTitle("Time and Date", stepTooltip.time) }
          />
          <Steps.Step
            className="steps-step2"
            disabled={ !canOpenEmployeeStep }
            title={ renderStepTitle("Employees", stepTooltip.employees) }
          />
          <Steps.Step
            className="steps-step3"
            disabled={ !canOpenFinalStep }
            title={ renderStepTitle("Finalise", stepTooltip.finalise) }
          />
        </Steps>

        <div className="create-roster-content">
          { currentStep === 0 ?
            <StepOne timeSlots={ timeSlots } initialValues={ firstStepData } response={ getStepOneData } onCancel={ onCancel } />
            : currentStep === 1 && hasCompanyRelatedData ?
              <FilterSelectEmployees setSelectedEmploymentsIds={ setSelectedEmploymentsIds } initialValues={ preEmployeesFilter } companyRelatedData={ companyRelatedData } onCancel={ onCancel } onBack={ onBack }
                employment_ids={ selectedEmployments }
                moduleName='companyRoaster' selected={ selectedEmployees } unSelected={ unSelectedEmployees } preFilters={ preEmployeesFilter } setSelected={ setSelectedEmployees } setUnselected={ setUnSelectedEmployees } setPrefilters={ setPreEmployeesFilter }
              />
              : currentStep === 2 ?

                <Preview previewData={ previewData } dates={ dates } /> : <div className="create-roster-step-loading"><Spin spinning tip="Loading employees..." /></div> }
        </div>
      </div>

      <div className="create-roster-footer">
        { currentStep > 0 ?
          <Button className="button-back" onClick={ () => setCurrent(currentStep - 1) }>
            <span style={ { color: "#4079FC" } }>Back</span>
          </Button>
          : null }
        { currentStep === 0 ?
          <Button className="button-next" type="primary" htmlType="submit" form="createRosterStepOneForm">Next <ArrowRightOutlined /></Button>
          : currentStep === 1 ?
            <Button className="button-next" type="primary" htmlType="submit" form="filterEmployeeForm" disabled={ !hasCompanyRelatedData }>Next <ArrowRightOutlined /></Button>
            : <SaveButton className="button-next" text={ "Submit" } loading={ saveLoader } form={ formName } key="create_button" onClick={ () => onSubmit(firstStepData) } disabled={ !canOpenFinalStep } /> }
      </div>

      { childComponent }
    </ModalComponent>
  )
}
export default CreateCompanyRoaster
